var map = {
	"./1985_Population_totalRate.png": 255,
	"./1986_Population_totalRate.png": 256,
	"./1987_Population_totalRate.png": 257,
	"./1988_Population_totalRate.png": 258,
	"./1989_Population_totalRate.png": 259,
	"./1990_Population_totalRate.png": 260,
	"./1991_Population_totalRate.png": 261,
	"./1992_Population_totalRate.png": 262,
	"./1993_Population_totalRate.png": 263,
	"./1994_Population_totalRate.png": 264,
	"./1995_Population_totalRate.png": 265,
	"./1996_Population_totalRate.png": 266,
	"./1997_Population_totalRate.png": 267,
	"./1998_Population_totalRate.png": 268,
	"./1999_Population_totalRate.png": 269,
	"./2000_Population_totalRate.png": 270,
	"./2001_Population_totalRate.png": 271,
	"./2002_Population_totalRate.png": 272,
	"./2003_Population_totalRate.png": 273,
	"./2004_Population_totalRate.png": 274,
	"./2005_Population_totalRate.png": 275,
	"./2006_Population_totalRate.png": 276,
	"./2007_Population_totalRate.png": 277,
	"./2008_Population_totalRate.png": 278,
	"./2009_Population_totalRate.png": 279,
	"./2010_Population_totalRate.png": 280,
	"./2011_Population_totalRate.png": 281,
	"./2012_Population_totalRate.png": 282,
	"./2013_Population_totalRate.png": 283,
	"./2014_Population_totalRate.png": 284,
	"./2015_Population_totalRate.png": 285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;